const isEmptySortValue = (value) => value === null || typeof value === 'undefined';

const compareSortValues = (firstValue, secondValue, order) => {
	const firstValueIsEmpty = isEmptySortValue(firstValue);
	const secondValueIsEmpty = isEmptySortValue(secondValue);

	if (firstValueIsEmpty || secondValueIsEmpty) {
		if (firstValueIsEmpty && secondValueIsEmpty) {
			return 0;
		}

		return firstValueIsEmpty ? 1 : -1;
	}

	const comparison =
		typeof firstValue === 'string'
			? firstValue.localeCompare(secondValue)
			: firstValue - secondValue;
	return order === 'asc' ? comparison : -comparison;
};

export const sortRows = (rows, getSortValue, order = 'asc') => {
	return rows
		.map((row, index) => ({ row, index, sortValue: getSortValue(row) }))
		.sort((firstItem, secondItem) => {
			const comparison = compareSortValues(firstItem.sortValue, secondItem.sortValue, order);
			return comparison || firstItem.index - secondItem.index;
		})
		.map(({ row }) => row);
};
